<template>
  <div class="container">
    <div class="poster-bg">
      <div class="poster-container">
        <div class="poster-title">阅读报告</div>
        <div v-if="articleResult.congratulation" class="poster-desc">
          {{ articleResult.congratulation.subTitle }}
        </div>
        <div class="poster-left-title">
          {{ `今日阅读文章` }}
        </div>
        <div v-if="articleResult.contentTitle" class="poster-desc">
          {{ articleResult.contentTitle.replace(/&nbsp;/g, " ") }}
        </div>
        <div class="poster-right-title">阅读难度</div>
        <div class="poster-right-level">
          <div
            style="
              border: 1px solid #333333;
              padding: 0 20px;
              line-height: 24px;
            "
          >
            {{ articleResult.difficultyTitle }}
          </div>
        </div>
      </div>
    </div>
    <!-- </div> -->
    <div class="content-container">
      <div class="content-title">答题情况</div>
      <div class="answer-result-example">
        <div class="correct-circle"></div>
        <div>正确</div>
        <div class="wrong-circle"></div>
        <div>错误</div>
      </div>
      <div class="answer-result-container">
        <div
          :class="
            item.isCorrect ? 'answer-result-item' : 'answer-result-wrong-item'
          "
          v-for="(item, index) in questionsResult"
          :key="index"
        >
          {{ index + 1 }}
        </div>
      </div>
      <div
        v-if="articleResult.answerRewardPoint || articleResult.readRewardPoint"
        class="content-title"
      >
        阅读奖励
      </div>

      <div
        v-if="articleResult.answerRewardPoint || articleResult.readRewardPoint"
        class="answer-reward-container"
      >
        <div v-if="articleResult.readRewardPoint" class="answer-reward-item">
          <div>阅读奖励</div>
          <div>+{{ articleResult.readRewardPoint }}</div>
        </div>
        <div v-if="articleResult.answerRewardPoint" class="answer-reward-item">
          <div>答题奖励</div>
          <div>+{{ articleResult.answerRewardPoint }}</div>
        </div>
      </div>
    </div>
    <div style="height: 10px; background: #f7f8fb"></div>
    <div
      v-if="recommendArticle && recommendArticle.articleId"
      class="recommend-container"
    >
      <div class="content-title">猜你还喜欢这些文章</div>
      <div class="card-item" @click="onArticleClick(recommendArticle)">
        <div class="article-image-container">
          <div>
            <img class="article-intro-image" :src="recommendArticle.imageUrl" />
          </div>
        </div>
        <div v-if="recommendArticle.keyword" class="article-catagory">— {{ recommendArticle.keyword }} —</div>
        <div v-if="recommendArticle.title" class="article-desc-en">{{ recommendArticle.title.replace(/&nbsp;/g, ' ') }}</div>
        <div v-if="recommendArticle.titleCn" class="article-desc-cn">{{ recommendArticle.titleCn.replace(/&nbsp;/g, ' ') }}</div>
        <div class="article-source">
          {{ `选自${recommendArticle.source} (${recommendArticle.sourceCn})` }}
        </div>
      </div>
    </div>

    <answer-result-footer
      :active="activeFooter"
      text="晒成绩"
      :onItemClick="this.onFooterClick"
      :onButtonClick="this.shareResult"
    />

    <wrong-answer-modal
      v-if="activeFooter == ANSWER_RESULT_FOOTER_TYPE.WRONG_ANSWER"
      v-show="activeFooter == ANSWER_RESULT_FOOTER_TYPE.WRONG_ANSWER"
      :onClose="this.onModalClose"
    ></wrong-answer-modal>

    <new-word-modal
      v-if="activeFooter == ANSWER_RESULT_FOOTER_TYPE.NEW_WORD"
      v-show="activeFooter == ANSWER_RESULT_FOOTER_TYPE.NEW_WORD"
      :onClose="this.onModalClose"
    />

    <van-popup
      v-model="vote_show"
      :close-on-click-overlay="false"
      :closeable="true"
      @close="onCloseVoteAlert"
    >
      <vote-alert
        :voteTitle="voteTitle"
        @onClickVote="onClickVote"
      ></vote-alert>
    </van-popup>
    <van-popup
      v-model="vote_summary_show"
      :close-on-click-overlay="false"
      :closeable="true"
      @close="onCloseVoteSummaryAlert"
    >
      <vote-summary-alert
        @onClickVoteShare="onClickVoteShare"
        :voteSummary="voteSummary"
      ></vote-summary-alert>
    </van-popup>
  </div>
</template>
<script>
import AnswerResultFooter from "../../components/footer/AnswerResultFooter";
import NewWordModal from "./component/NewWordModal";
// import QuizListModal from "./component/QuizListModal";
import WrongAnswerModal from "./component/WrongAnswerModal";
import { ANSWER_RESULT_FOOTER_TYPE } from "../../contants/article";
import AnswerProgress from "./component/AnswerProgress";
import OptionGroup from "./component/OptionGroup";
import _ from "lodash";
import { Toast } from "vant";
import moment from "moment";

import VoteAlert from "@/components/vote/VoteAlert";
import VoteSummaryAlert from "@/components/vote/VoteSummaryAlert";
import {
  whetherVoted,
  userVote,
  userVoteResult,
  userVoteShareGetInfo,
} from "@/api/vote";
import { ShareSource } from "../../contants";
import { mapState } from "vuex";
import { getSimilarArticle, getDailyShareInfo } from "@/api/article";
export default {
  name: "AnswerResultPage",
  data() {
    return {
      ANSWER_RESULT_FOOTER_TYPE: ANSWER_RESULT_FOOTER_TYPE,
      FOOTER_ITEMS: [
        {
          label: "当前难度",
          type: ANSWER_RESULT_FOOTER_TYPE.LEVEL,
        },
        {
          label: "文章导读",
          type: ANSWER_RESULT_FOOTER_TYPE.WRONG_ANSWER,
        },
        {
          label: "生词本",
          type: ANSWER_RESULT_FOOTER_TYPE.NEW_WORD,
        },
      ],
      activeFooter: 0,
      recommendArticle: {},
      vote_show: false,
      vote_summary_show: false,
      scene: 2, // 阅读后投票
      voteSummary: {},
    };
  },

  components: {
    AnswerResultFooter,
    AnswerProgress,
    OptionGroup,
    NewWordModal,
    WrongAnswerModal,
    VoteAlert,
    VoteSummaryAlert,
  },

  mounted() {
    console.log("==========>");
  },
  activated() {
    let articleId = this.articleId;
    
    articleId && getSimilarArticle({ articleId }).then((result) => {
      this.recommendArticle = result.data;
    });

    //展示投票弹框
    if (this.voteTitle && this.voteTitle.length > 0) {
      this.whetherVoted();
    }

    // this.answer = new Array(this.quizData.questions.length);
    // testToken()
    //   .then((result) => {
    //     console.log("testToken => ", result);
    //   })
    //   .catch((err) => {
    //     console.log("error  => ", err);
    //   });
  },
  computed: {
    ...mapState({
      articleId: (state) => state.article.articleDetail.articleId,
      contentId: (state) => state.article.contentId,
      startTime: (state) => state.article.startTime,
      answer: (state) => state.article.answer,
      quizData: (state) => state.article.quizData,
      levels: (state) => state.article.levels,
      articleResult: (state) => state.article.articleResult,
      voteTitle: (state) => state.article.articleDetail.voteTitle,
    }),
    questionsResult() {
      let answer = this.quizData.questions;
      _.map(answer, (question, index) => {
        question.isCorrect = false;
        console.log("=====>", this.answer[index], index);
        let selectOption = this.answer[index].optionId;
        _.map(question.options, (option) => {
          if (option.isCorrect && selectOption == option.optionId) {
            question.isCorrect = true;
          }
        });
      });
      return answer;
    },
  },

  methods: {
    onBack() {
      this.$router.replace({
        path: "/home",
      });
    },
    onArticleClick(article) {
      this.$router.replace({
        path: "/articleGuide",
        query: { articleId: article.articleId },
      });
    },
    onFooterClick(footerType) {
      if (footerType == ANSWER_RESULT_FOOTER_TYPE.LEVEL) {
        Toast("答题过程中不能修改文章难度");
      } else {
        this.activeFooter = footerType;
      }
    },
    shareResult() {
      console.log("===>", "asdfasdf");
      if (this.articleResult.congratulation) {
        getDailyShareInfo({
          congratulations: this.articleResult.congratulation,
          conclusion: this.articleResult.conclusion,
          contentId: this.contentId,
          level: this.articleResult.congratulation.level,
          shareSource: ShareSource.DAILY_REPORT_SHARE,
        })
          .then((res) => {
            this.$router.push({
              path: "/share/dailyReport",
              query: {
                shareReadRecordId: res.data.businessId,
                shareRecordId: res.data.shareRecordId,
                bySelf: true,
              },
            });
          })
          .catch(() => {});
      }
    },
    onModalClose() {
      this.activeFooter = 0;
    },

    // 投票===start====
    whetherVoted() {
      let parmas = {
        articleId: this.articleId,
        scene: this.scene,
      };
      whetherVoted(parmas)
        .then((res) => {
          if (!res.data) {
            this.vote_show = true;
          } else {
            this.userVoteResult();
          }
        })
        .catch((err) => {
          this.userVoteResult();
        });
    },
    onCloseVoteAlert() {
      this.vote_show = false;
      this.userVoteResult();
    },
    onCloseVoteSummaryAlert() {
      this.vote_summary_show = false;
    },
    onClickVote(viewpoint) {
      let parmas = {
        articleId: this.articleId,
        scene: this.scene,
        viewpoint: viewpoint,
      };
      userVote(parmas)
        .then((res) => {
          this.userVoteResult();
        })
        .catch((err) => {});
    },
    userVoteResult() {
      userVoteResult({ articleId: this.articleId }).then((result) => {
        this.voteSummary = result.data;
        this.vote_show = false;
        this.vote_summary_show = true;
      });
    },
    onClickVoteShare() {
      let params = {
        articleId: this.articleId,
        shareSource: ShareSource.VOTE_SUNMMARY_SHARE,
      };
      userVoteShareGetInfo(params).then((res) => {
        this.$router.push({
          path: "/share/voteShare",
          query: {
            articleId: res.data.businessId,
            shareRecordId: res.data.shareRecordId,
            showGuide: true,
            bySelf: true,
          },
        });
        this.vote_summary_show = false;
      });
    },
    // 投票===end====
  },
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.container {
  min-height: 100vh;
  padding-bottom: 50px;
  background: #ffffff;
}

.poster-container {
  width: 100%;
  height: 100%;
  padding: 15px;
}

.poster-bg {
  width: 100vw;
  height: 140vw;
  background-image: url('../../assets/imgs/article/answer-result-bg.png');
  background-size: 100% 100%;
  display: flex;
}

.poster-title {
  margin-left: auto;
  text-align: center;
  width: 50px;
  height: 50px;
  padding: 10px;
  line-height: 24px;
  font-size: 18px;
  font-weight: bold;
  font-family: serif,SimSun,STSong;
  border: 1px solid #333333;
}

.poster-desc {
  font-size: 14px;
  line-height: 40px;
  max-width : 90vw;
  font-family: serif,SimSun,STSong;
}

.poster-left-title {
  line-height: 30px;
  font-size: 18px;
  font-weight: bold;
  font-family: serif,SimSun,STSong;
}

.poster-right-title {
  margin-left: auto;
  text-align: right;
  font-weight: bold;
  line-height: 30px;
  font-size: 18px;
  font-family: serif,SimSun,STSong;
}

.poster-right-level {
  display: flex;
  margin-top: 6px;
  font-size: 14px;
  font-family: serif,SimSun,STSong;
  justify-content: flex-end;
}

.content-container {
  flex: 1;
  padding: 15px;
  background: #ffffff;
  overflow: scroll;
}

.content-title {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  font-family: serif,SimSun,STSong;
}

.answer-result-example {
  display: flex;
  align-items: center;
  line-height: 14px;
  font-size: 12px;
  -webkit-transform-origin-x: 0;
  transform: scale(0.9);
  font-family: serif,SimSun,STSong;
  margin-bottom: 4px;
}

.correct-circle {
  height: 14px;
  width: 14px;
  background: linear-gradient(top, #98CEFF, #3994E7);
  border-radius: 7px;
  margin-right: 8px;
}

.wrong-circle {
  margin-left: 20px;
  margin-right: 8px;
  height: 14px;
  width: 14px;
  background: #FF7676;
  border-radius: 7px;
}

.answer-result-container {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  padding: 25px 23px;
  border-radius: 10px;
  border: 1px solid #3994E7;
  margin-bottom: 20px;
}

.answer-result-item {
  width: 32px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  padding: auto;
  background: linear-gradient(top, #98CEFF, #3994E7);
  border-radius: 16px;
  font-size: 18px;
  font-weight: bold;
  color: #ffffff;
}

.answer-result-wrong-item {
  width: 32px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  padding: auto;
  background: #FF7676;
  border-radius: 16px;
  font-size: 18px;
  font-weight: bold;
  color: #ffffff;
}

.answer-reward-container {
  justify-content: space-between;
  padding: 20px 23px;
  border-radius: 10px;
  border: 1px solid #3994E7;
  margin-bottom: 20px;
}

.answer-reward-item {
  display: flex;
  justify-content: space-between;
  padding: 0 30px;
  line-height: 30px;
  font-size: 14px;
  font-family: serif,SimSun,STSong;
}

.recommend-container {
  flex: 1;
  padding: 20px 15px;
  background: #ffffff;
}

.card-item {
  // background-color :
  background-color: #ffffff;
  border-radius: 16px;
  box-shadow: 0px 20px 100px 0px #d6d6d6;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 38px;
}

.article-image-container {
  display: flex;
  position: relative;
  text-align: center;
}

.article-intro-image {
  position: relative;
  width: 100%;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
}

.article-play-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 12vw;
  height: 12vw;
  transform: translate(-50%, -50%);
}

.article-catagory {
  margin-top: 24px;
  font-size: 13px;
  font-weight: bold;
  color: #999999;
  font-family: serif,SimSun,STSong;
}

.article-desc-en {
  margin: 0 15px;
  margin-top: 24px;
  font-size: 14px;
  text-align: center;
  color: #333333;
  font-family: serif,SimSun,STSong;
}

.article-desc-cn {
  margin-top: 15px;
  font-size: 14px;
  color: #333333;
  font-weight: bold;
  font-family: serif,SimSun,STSong;
}

.article-source {
  margin-top: 15px;
  font-size: 11px;
  color: #999999;
  font-family: serif,SimSun,STSong;
}
.card-container {
  width: 100%;
}

.button-group-option {
  display: flex;
  justify-content: space-between;
}
</style>


// WEBPACK FOOTER //
// app/pages/article/AnswerResultPage.vue